/**
 * Mijn account-overlay (client-state, Zustand).
 *
 * Twee plekken openen hem: het menu-item linksonder, en een zoekresultaat op
 * de instellingen-pagina dat naar een persoonlijke instelling wijst. Een
 * gedeelde schakelaar is minder omslachtig dan de toestand door de hele
 * app-schil heen doorgeven.
 */
import { create } from 'zustand';

interface AccountOverlayState {
  open: boolean;
  /** Sectie waarop de overlay opent; leeg = de eerste. */
  section: string | undefined;
  show: (section?: string) => void;
  setOpen: (open: boolean) => void;
}

export const useAccountOverlay = create<AccountOverlayState>((set) => ({
  open: false,
  section: undefined,
  show: (section) => set({ open: true, section }),
  setOpen: (open) => set({ open }),
}));
